import React from 'react';

const cn = (...classes: (string | undefined | null | false)[]): string =>
    classes.filter(Boolean).join(' ');

interface VideoPlayerProps {
    videoUrl: string;
    className?: string;
    emptyMessage?: string;
}

export const VideoPlayer: React.FC<VideoPlayerProps> = ({
    videoUrl,
    className,
    emptyMessage = 'No video available'
}) => {
    const [videoReady, setVideoReady] = React.useState(false);

    React.useEffect(() => {
        setVideoReady(false);
    }, [videoUrl]);

    if (!videoUrl) {
        return (
            <div
                className={cn(
                    'w-full h-full flex items-center justify-center text-gray-600 bg-gray-200',
                    className
                )}
            >
                {emptyMessage}
            </div>
        );
    }

    return (
        <div className={cn('relative w-full h-full bg-black', className)}>
            {!videoReady && (
                <div className="absolute inset-0 flex items-center justify-center bg-black/40 z-10">
                    <div className="h-8 w-8 rounded-full border-2 border-gray-300 border-t-white animate-spin" />
                </div>
            )}
            <video
                key={videoUrl}
                className="w-full h-full object-contain"
                controls
                preload="auto"
                playsInline
                webkit-playsinline="true"
                onCanPlay={() => setVideoReady(true)}
                onLoadedMetadata={() => setVideoReady(true)}
                onError={() => setVideoReady(true)}
            >
                <source src={videoUrl} type="video/mp4" />
                <source src={videoUrl} type="video/quicktime" />
                Oops! It looks like your browser isn&apos;t feeling up to playing this video.
            </video>
        </div>
    );
};

export default VideoPlayer;
